module.exports = __webpack_public_path__ + "194b93ff4919c56fa157eb1e16acd621.webp";